<app-whiteboard-search [whiteboardList]="whiteboardList"></app-whiteboard-search>
<ul #whiteboardList class="whiteboard-drawing-list">
    @for (whiteboard of whiteboardsList; track whiteboard) {
        @if (!pageService.hasLimitedView() || !whiteboard.page_id ||
        (pageService.hasLimitedView() && pageService.getGetViewablePagesIDs().includes(whiteboard.page_id))) {
            <li [id]="itemIdPrefix + whiteboard.id">
                <app-whiteboard-drawings-list-item [whiteboard]="whiteboard"></app-whiteboard-drawings-list-item>
                <hr>
                {{ setListNotEmpty() }}
            </li>
        }
    }
</ul>
@if (listEmpty || whiteboardService.getWhiteboardsFromSubject().length == 0) {
    <div class="text-center">
        Keine Tafelbilder gefunden.
    </div>
}
